import { Component, OnInit, ViewChild, Input } from '@angular/core'; 
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { OverrideRuleService } from '../../shared/services/overrideRule.service';
import { OverrideRule } from '../../shared/models/overrideRule';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { OverrideRuleEditFormComponent } from '../../shared/components/modals/override-rule-edit-modal/override-rule-edit.component';
import { OverrideRuleAddFormComponent } from '../../shared/components/modals/override-rule-add-modal/override-rule-add.component';
import { FileService } from '../../shared/services/file.service';

 

@Component({
  selector: 'app-overriderules', 
  templateUrl: './override-rules.component.html'
})

export class OverrideRulesComponent implements OnInit {  
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<OverrideRule>();
  displayedColumns: string[] = ['actions', 'id', 'brandName', 'campaignTypeName', 'storeLocationName', 'months', 'ageRangeName', 'gender', 'priority','startDate','endDate'];
  //addForm: LocationAddFormComponent;
  public now: Date;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private overrideRuleService: OverrideRuleService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService,
    private fileService: FileService
  ) { }
   
  private _id; // private property _item

  // use getter setter to define the property
  get id(): any {
    return this._id;
  }

  @Input()
  set id(val: any) { 
    this._id = val; 
  } 

  // call get locations on load 
  ngOnInit() {
    this.getRecords(this.id);
    this.now = new Date();
  }

  // get matrix records
  getRecords(id: number): void {
    if (id > 0) {  
      this.overrideRuleService.getAll(id).subscribe(result => { 
          this.dataSource.data = result;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 
      }, error => console.error(error));
    }
  }

  // open add form for location
  openAddModal() {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(OverrideRuleAddFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Add new rule';
    modalRef.componentInstance.brandId = this.id;
     
    // modal result
    modalRef.result.then((result) => { 
        this.getRecords(this.id); 
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    ); 
  }

  // copy entry
  copyOverrideRule(item: OverrideRule): void {

    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(OverrideRuleAddFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Copy rule';
    modalRef.componentInstance.brandId = this.id;
    modalRef.componentInstance.model = item;

    // modal result
    modalRef.result.then((result) => {
      this.getRecords(this.id);
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    ); 
  }

  // delete creative template entry
  deleteOverrideRule(id: number) {

    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {  
        if (confirmed) {
          this.overrideRuleService.delete(id).subscribe((result) => {
              this.showNotification('The item has been deleted successfully!', 'Okay!');
              this.getRecords(this.id);
            });
          }
        }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      ); 
  }

  // edit location
  editOverrideRule(item: OverrideRule) {

      this.overrideRuleService.getById(item.id).subscribe(ct => {
          let template = ct;
          let modalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
          };

          const modalRef = this.modalService.open(OverrideRuleEditFormComponent, modalOptions);
          modalRef.componentInstance.title = 'Edit Rule';
          modalRef.componentInstance.overrideRule = ct;

          // modal result
          modalRef.result.then((result) => {
            if (result) {
              this.getRecords(this.id);
            }
          }).catch(() =>
            console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
          );

      }); 
  }

  exportData() { 
    let headerList: Array<string> = [
      "campaignTypeName",
      "brandName",
      "months",
      "ageRangeName",
      "gender",
      "priority",
      "startDate",
      "endDate"
    ];
    this.fileService.downloadFile(this.dataSource.data, headerList, "datafile");
  }
    
  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
   
  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
   
}

